import { render } from "./StockSimulatorPage.vue?vue&type=template&id=88df1702&scoped=true"
import script from "./StockSimulatorPage.vue?vue&type=script&lang=js"
export * from "./StockSimulatorPage.vue?vue&type=script&lang=js"

import "./StockSimulatorPage.vue?vue&type=style&index=0&id=88df1702&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88df1702"]])

export default __exports__